import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import Cookies from 'js-cookie';
import { fg } from '@atlaskit/platform-feature-flags';
import { getBscGlobalState, sendPackageOperationalEvent } from '../../../common/utils';
import { isProcessingAllowedByPreferences } from '../../../common/utils/item-processing';
import { Logger } from '../../../common/utils/logger';
import { CategoryStorageType, Status } from '../../../types';
/**
 * Sets a cookie asynchronously. This queries user preferences before setting
 * the cookie, so it must be used for any cookies which are not strictly
 * necessary.
 */
export var setCookie = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(key, value, attributes) {
    var productName, shouldSetCookie, eventAttributes;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          if (!fg('platform_moonjelly_bsc_master_killswitch')) {
            _context.next = 3;
            break;
          }
          // Set the cookie without checking user preferences
          // when master killswitch is enabled
          Cookies.set(key, value, _objectSpread(_objectSpread({}, attributes), {}, {
            'atl-set-cookie': true
          }));
          return _context.abrupt("return", Status.SUCCESS);
        case 3:
          // user belongs to an org that opted into cookies management and we should respect their preferences
          productName = getBscGlobalState().product; // Flag enabled, user belongs to an org that opted into cookies management and we should respect their preferences
          _context.next = 6;
          return isProcessingAllowedByPreferences({
            itemKey: key,
            storageType: CategoryStorageType.Cookies,
            productName: productName
          });
        case 6:
          shouldSetCookie = _context.sent;
          eventAttributes = {
            wasRejected: !shouldSetCookie,
            cookieKey: key
          };
          _context.prev = 8;
          sendPackageOperationalEvent({
            action: 'usedSetCookie',
            attributes: eventAttributes
          });
          if (!shouldSetCookie) {
            _context.next = 15;
            break;
          }
          Cookies.set(key, value, _objectSpread(_objectSpread({}, attributes), {}, {
            'atl-set-cookie': true
          }));
          return _context.abrupt("return", Status.SUCCESS);
        case 15:
          return _context.abrupt("return", Status.BLOCKED);
        case 16:
          _context.next = 22;
          break;
        case 18:
          _context.prev = 18;
          _context.t0 = _context["catch"](8);
          Logger.errorWithOperationalEvent({
            action: 'usedSetCookieError',
            attributes: eventAttributes,
            message: "Failed to use set cookie. ".concat(_context.t0.message || '')
          });
          return _context.abrupt("return", Status.BLOCKED);
        case 22:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[8, 18]]);
  }));
  return function setCookie(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();